import React from "react";

import { ITransactionDetailType, ITransactionHistoryType } from "@/types/TransactionTypes";
import { twelveDReds, fortyEightDReds, rouletteReds, twentyFourDReds, shioFightsAnimals, regexIndexOf, tempDataPage } from "./commonMobile";
import { assetImg } from "./moduleImporter";
import { IKeyStringDict } from "@/types/GlobalTypes";
import nth0 from "./nth0";
import { newGetPcode, getBasePcode } from "./gamePcode";

export interface ITransactionHistoryState {
	//Transaction
	showTransactionHistoryPopup: boolean;
	showTransactionHistoryLoadingOverlay: boolean;
	transactionHistoryData: any;
	transactionHistoryPage: number;
}

const defaultTransactionHistoryState = {
	// Shows PopupTransactionHistory component
	showTransactionHistoryPopup: false,
	showTransactionHistoryLoadingOverlay: false,
	transactionHistoryData: null,
	transactionHistoryPage: 0
}

/* Rewrite */
function fetchTransactionHistory(e?: any) {
	const mainClass = this;

	let targetPage = 1;

	if (e)
		targetPage = e.currentTarget.getAttribute("page");

	mainClass.setState({
		showTransactionHistoryLoadingOverlay: true,
		transactionHistoryPage: targetPage
	});

	const request = mainClass.state.useTempData ?
		new Request(tempDataPage + "?page=transactions") :
		new Request("/games/transactions/" + targetPage);

	let init: RequestInit;
	if (!mainClass.state.useTempData)
		init = { credentials: "same-origin" };

	fetch(request, init)
		.then(res => res.json())
		.then(data => {
			//Todo: consult this with backend devs
			for (const a in data.transaction) {
				// data.transaction[a].idbel = Number(data.transaction[a].idbel);
				// data.transaction[a].agent = Number(data.transaction[a].agent);
				data.transaction[a].periode = Number(data.transaction[a].periode);
				data.transaction[a].totalBalance = Number(data.transaction[a].totalBalance);
			}


			mainClass.setState({
				transactionHistoryData: data,
				showTransactionHistoryLoadingOverlay: false
			});
		});
}

/**
 * Same as fetchTransactionHistory but without fetch()
 */
function changeTransactionPage(e: React.MouseEvent) {
	const mainClass = this;
	const targetPage = e.currentTarget.getAttribute("page");

	mainClass.setState({
		transactionHistoryPage: targetPage
	});
}

type transactionDetailFetchType = {
	game: string,
	periode: number,
	idbel: string,
	tglbel: string,
}

function fetchTransactionDetail(mainClass: any, e: transactionDetailFetchType) {
	let game = "",
		periode = 0,
		idbel = "",
		tglbel = "";

	if (e) {
		// game = e.currentTarget.getAttribute("game");
		// periode = Number(e.currentTarget.getAttribute("periode"));
		// idbel = Number(e.currentTarget.getAttribute("idbel"));
		game = e.game;
		periode = Number(e.periode);
		idbel = e.idbel;
		tglbel = e.tglbel;
	} else alert("Incomplete request, cancelling.");

	// console.log("fTD", e);

	mainClass.setState({
		showTransactionHistoryLoadingOverlay: true
	});

	const request = mainClass.state.useTempData ?
		new Request(tempDataPage + "?page=detail-transaction") :
		new Request("/games/detail-transaction/" + tglbel + "/" + periode + "/" + idbel);

	let init: RequestInit;
	if (!mainClass.state.useTempData)
		init = { credentials: "same-origin" };

	fetch(request, init)
		.then(res => res.json())
		.then((data: ITransactionDetailType[]) => {
			// console.log("fTD data: ", data);

			//filter by idbel, then fill transactionHistoryData with the index, with data as transactionDetail
			const transactionHistoryData: ITransactionHistoryType =
				mainClass.state.transactionHistoryData;

			const filtered = transactionHistoryData.transaction.filter(item =>
				String(item.idbel) === idbel
			);

			if (filtered && filtered.length > 0) {
				const index = transactionHistoryData.transaction.indexOf(filtered[0]);
				const relatedTransaction = transactionHistoryData.transaction[index];
				relatedTransaction.transactionDetail = data;

				const transactionDetail = relatedTransaction.transactionDetail;

				//Sums totalWin
				let totalWin = 0;
				transactionDetail.forEach((item: { total: number; }) => {
					totalWin += item.total; //item.prize * item.taruhan
				});


				// Process contents as necessary, according to specific games
				// relatedTransaction.game = game;

				//Displayed at the bottom of transaction detail
				relatedTransaction.totalWin = totalWin;

				// Converts Tebak column to pictures as necessary
				convertTransactionTebak(transactionDetail, game, periode, idbel);
			}

			mainClass.setState({
				transactionHistoryData: transactionHistoryData,
				showTransactionHistoryLoadingOverlay: false
			});
		});
}

function isGongBallHistoryCard(str: string) {
	return /A|[0-9]|J|Q|K/g.test(str);
}

//Summary:
//  Converts transaction history detail to icons
//Parameters:
//  transactionDetailObject
//  game
//  periode
//  idbel
function convertTransactionTebak(
	transactionDetailObject: ITransactionDetailType[],
	game: string,
	periode: string | number,
	idbel: string
) {

	// console.log("cTT params", transactionDetailObject, game, periode, idbel);

	//Note: no need to change key template
	const pcode = newGetPcode(game);
	const basePcode = getBasePcode(pcode);

	//Template styles
	const inlineBlockStyle = { display: "inline-block", verticalAlign: "middle" };

	//transactionDetailObject.forEach((item, idx) => {
	// Input: item.tebak
	// Output: item.convertedTebak
	//});

	const assetTebak = basePcode === "m37" ? "p12" : basePcode;

	// console.log("p bP", pcode, basePcode);

	switch (basePcode) {
		//Sicbo Dice
		case "p12":
		case "m31":
		case "m37":
			transactionDetailObject.forEach((item: ITransactionDetailType) => {
				if (item.type === "s")
					// display convertedTebak instead of plain tebak
					item.convertedTebak = "Total " + item.tebak;
				else if (item.tebak.indexOf(",") >= 0 || !isNaN(+item.tebak))
					//Convert array with comma and one dice
					item.convertedTebak = (
						<div key={"tHD_det_" + game + "_" + periode + "_" + idbel}>
							{
								//Splits pictures by ","
								item.tebak.split(",").map((subItem: string, subIdx: number) =>
									subItem !== "" ?
										assetImg(assetTebak,
											subItem + (basePcode === "m31" ? ".svg" : ""),
											"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + subIdx) :
										null
								)
							}
						</div>
					);
			});
			break;

		//Oglok
		case "m7":
			transactionDetailObject.forEach((item: ITransactionDetailType) => {
				if (item.tebak === "anytriple") return;
				else
					// display convertedTebak instead of plain tebak
					item.convertedTebak = item.tebak.split(",").map((num: string, idx: number) =>
						assetImg("m7", num + "", "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx)
					);
			});
			break;

		//Red White
		case "m11":
			transactionDetailObject.forEach((item: ITransactionDetailType) => {
				// display convertedTebak instead of plain tebak
				item.convertedTebak = item.tebak.split(",").map((num: string, idx: number) =>
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}
						className={
							"converted " + (
								num === "white" ? "sl-white" :
									num === "red" ? "sl-red" :
										"sl-yellow")
						}
					>
						{num === "3" ? "JP" : "\u00a0"}
					</div>
				);
			});
			break;

		//Head & Tail
		case "m10":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				const htHead = assetImg("m10", "1"),
					htTail = assetImg("m10", "2");

				// display convertedTebak instead of plain tebak
				switch (item.tebak) {
					//head tail
					case "head":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								{htHead}
								{item.tebak}
							</div>
						);
						break;
					case "tail":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								{htTail}
								{item.tebak}
							</div>
						);
						break;

					//left right
					case "left":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}
								className="sl-red">
								{item.tebak}
							</div>
						);
						break;
					case "right":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								{item.tebak}
							</div>
						);
						break;

					//c1: 112
					//c2: 221
					case "c1":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								Any {htHead}
								{htHead}
								{htTail}
							</div>
						);
						break;
					case "c2":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								Any {htTail}
								{htTail}
								{htHead}
							</div>
						);
						break;


					//d1, d3, d5: 1
					case "d1":
					case "d3":
					case "d5":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								Coin {(+item.tebak[1] + 1) / 2} {htHead}
							</div>
						);
						break;

					//d2, d4, d6: 2
					case "d2":
					case "d4":
					case "d6":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								Coin {+item.tebak[1] / 2} {htTail}
							</div>
						);
						break;



					//regular split sequence
					default:
						// console.log("default item", item);
						const arrItem = item.tebak.split(',');

						if (arrItem.length > 1) {
							item.convertedTebak = (
								<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
									{
										arrItem.map((subItem: string, subIdx: number) =>
											assetImg("m10",
												subItem === "head" ? "1" : "2",
												"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
										)
									}
								</div>
							);
						}
						else {
							item.convertedTebak = (
								<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
									Coin {item.tebak.split(' ')[1]}
									{
										item.tebak.search("head") >= 0 ? htHead : htTail
									}
								</div>
							)
						}
						break;
				}
			});
			break;


		case "p9":
		case "p6":
		case "m6":
		case "p7":
		case "m35":
		case "m36":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				// 24D/24D Spin/48D
				// Skip tebak that contains row/column
				if (item.tebak.indexOf("row") >= 0 ||
					item.tebak.indexOf("column") >= 0)
					return;

				//Convert 00 to green circle for Roulette
				if (basePcode === "p7" && item.tebak === "00") {
					item.convertedTebak = (
						<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
							<div className="circle sl-green-lighten">
								{item.tebak}
							</div>
						</div>
					);

					return;
				}

				//Convert red/black to a diamond
				if (item.tebak.indexOf(",") >= 0 || !isNaN(+item.tebak)) {
					item.convertedTebak = (
						<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
							{
								item.tebak.split(",").map((subItem: string, subIdx: number) =>
									<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx}
										className={
											"circle " +
											(
												(
													basePcode === "p9" ? twelveDReds :
														basePcode === "p6" || basePcode === "m6" ? twentyFourDReds :
															basePcode === "p7" || basePcode === "m36" ? rouletteReds :
																basePcode === "m35" ? fortyEightDReds : []
												).indexOf(Number(subItem)) >= 0 ?
													"bg-red" :
													"bg-black"
											)}>
										{subItem}
									</div>
								)
							}
						</div>
					);

					return;
				}

				// console.log("p9 i t", item.tebak);
			});
			break;

		//Billiards
		case "m13":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				if (item.tebak.indexOf(",") >= 0 ||
					!isNaN(+item.tebak))
					item.convertedTebak = item.tebak.split(",").map((subItem: any, subIdx: number) =>
						assetImg("m13", Number(subItem) + "", "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
					);
			});
			break;

		//Monopoly & Monopoly World Cup
		case "m20":
		case "m21":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				if (item.tebak.indexOf(",") >= 0)
					item.convertedTebak = item.tebak.split(",").map((subItem: any, subIdx: number) =>
						assetImg("m20", subItem, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
					);
			});
			break;

		//Gong Ball
		case "m16":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				if (!isNaN(+item.tebak))
					item.convertedTebak = assetImg("gb_cards", item.tebak, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx);

				switch (item.tebak) {
					case "3pic":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								{
									["J", "Q", "K"].map((subItem, subIdx) =>
										assetImg("gb_history", subItem, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
									)
								}
							</div>
						);
						break;
					case "2k":
						item.convertedTebak = (
							<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
								{assetImg("gb_history", "K", "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx)}
								{assetImg("gb_history", "K", "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx)}
							</div>
						);
						break;
					case "k":
						item.convertedTebak = assetImg("gb_history", "K", "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx);
						break;
					default: return;
				}
			});
			break;

		//Dice 6
		case "m8":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				if (!isNaN(+item.tebak))
					item.convertedTebak = assetImg("m8", item.tebak, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx);
			});
			break;

		//Poker Dice
		case "m14":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				if (!isNaN(+item.tebak[2]))
					item.convertedTebak = (
						<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
							{
								//Splits dices
								item.tebak.split(" ").map((subItem: any, subIdx: number) =>
									assetImg("m14", subItem, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
								)
							}
						</div>
					);
			});
			break;

		//Suwit
		case "m19":
			const handNames: IKeyStringDict = {
				stone: "batu",
				scissors: "gunting",
				paper: "kertas",

				thumb: "jempol",
				index: "telunjuk",
				pinky: "kelingking"
			};

			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
						{
							//Splits pictures by "-"
							item.tebak.split("-").map((subItem: string, subIdx: number) =>
								(subItem in handNames) ?
									assetImg("m19", handNames[subItem], "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
									: subItem
							)
						}
					</div>
				);
			});
			break;

		//Baccarat & IDN 4 Stand
		// case "m22":
		// case "m28":

		//Dragon Tiger
		case "m23":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
						{
							//Splits pictures by "-"
							item.tebak.split("-").map((subItem: string, subIdx: number) =>
								(subItem === "dragon" || subItem === "tiger") ?
									assetImg("m23", subItem, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
									: subItem
							)
						}
					</div>
				);
			});
			break;

		// case "m24":
		case "m25":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
						{
							((tebak) => {
								if (tebak.indexOf("ngatan") >= 0)
									return "NGA TAN " + tebak.replace("ngatan", "").substring(0, 2) + " - " + tebak[tebak.length - 1];
								else if (tebak.indexOf("kwok") >= 0)
									return "KWOK " + tebak[tebak.length - 2] + " & " + tebak[tebak.length - 1];
								else if (tebak.indexOf("fan") >= 0)
									return "FAN " + tebak[tebak.length - 1];
								else if (tebak.indexOf("shen") >= 0)
									return "SHENSAMHONG " + tebak.substring(tebak.length - 3, tebak.length);
								else if (tebak.indexOf("nim") >= 0)
									return tebak[0] + " NIM " + tebak[tebak.length - 1];

								return tebak.toUpperCase();
							})(item.tebak)
						}
					</div>
				);
			});
			break;

		//Lotto
		case "m26":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
						<div style={inlineBlockStyle}>
							(1st)
						</div>

						{
							//Splits pictures by ","
							item.tebak.split(",").map((subItem: string, subIdx: number) =>
								assetImg("m26", subItem + ".svg", "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
							)
						}

						<div style={inlineBlockStyle}>
							({nth0(item.tebak.split(",").length - 1)})
						</div>

						<div style={{
							...inlineBlockStyle,
							...{
								background: item.type === "random" ? "#dd603f" : "#5ea3a5",
								color: "white"
							}
						}}>

							({item.type})
						</div>
					</div>
				);
			});
			break;

		case "m27":
			const SFColours = {
				"di": "#B41B37",
				"tie": "green",
				"tian": "yellow"
			};

			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}
						className={"detail-transaction m27"}>
						{
							Object.keys(SFColours).indexOf(item.tebak) >= 0 ?
								<div className="circle" style={{
									color: item.tebak === "tian" ? "black" : "white",
									backgroundColor: SFColours[item.tebak],
								}}>
									{item.tebak}
								</div> :

								//Splits pictures by "-"
								item.tebak.split("-").map((subItem: string, subIdx: number) =>
									(shioFightsAnimals.indexOf(subItem) > -1) ?
										assetImg("shio_fight_bottom", subItem, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
										: subItem
								)
						}
					</div>
				);
			});
			break;

		case "m29":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}>
						{
							//Splits pictures by ","
							item.tebak.split(",").map((subItem: string, subIdx: number) =>
								subItem !== "" ?
									assetImg("m29", subItem + ".svg", "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx) :
									null
							)
						}
						<div style={inlineBlockStyle}>
							({
								item.type.indexOf("c") >= 0 ?
									"Colok " + item.type[1] + "D" :
									item.type[1] + "D"
							})
						</div>
					</div>
				);
			});

			break;

		case "m30":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}
						className={"detail-transaction m30"}>
						{
							regexIndexOf(item.tebak, /[0-9]/, 0) >= 0 ?
								//Splits pictures by comma
								// if it contains numbers
								item.tebak.split(",").map((subItem: any, subIdx: number) =>
									assetImg("m30", subItem, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx + "_" + subIdx)
								) : item.tebak //.replace("-", "_")
						}

						<div style={inlineBlockStyle}>
							({
								item.type === "n50" ? "50-50" :
									item.type.indexOf("c") >= 0 ?
										"Colok " + item.type[1] + "D" :
										item.type[1] + "D"
							})
						</div>
					</div>
				);
			});

			break;

		case "m33":
			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				let tebak = item.tebak.toUpperCase();
				tebak = tebak[tebak.length - 1];

				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}
						className={"detail-transaction m33"}>
						{
							isGongBallHistoryCard(tebak) ?
								assetImg("gb_history", tebak, "tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx) :
								item.tebak
						}
					</div>
				);
			});

			break;

		case "m39":
			const colours = {
				"red": "#b93332",
				"green": "#32972f",
				"blue": "#2155a8",

				"orange": "#D88326",

				"purple": "#7242C9",
				"grey": "#929292",
				"yellow": "#CAAA33"
			};

			const baseStyle: React.CSSProperties = {
				fontWeight: "bold",
				...inlineBlockStyle
			};

			const blackFont: React.CSSProperties = {
				color: "black"
			};
			const whiteFont: React.CSSProperties = {
				color: "white"
			};

			transactionDetailObject.forEach((item: ITransactionDetailType, idx: number) => {
				const { tebak, type } = item;

				const
					isRedWin = /red$/.test(tebak) && type === "n50",
					isBlueWin = /blue$/.test(tebak) && type === "n50",

					// single dice
					isD1Red = /red$/.test(tebak) && type === "d1",
					isD1Blue = /blue$/.test(tebak) && type === "d1",

					d1RedValue = isD1Red && tebak.match(/\d/)[0],
					d1BlueValue = isD1Blue && tebak.match(/\d/)[0],

					isTieNum = type === "tie_ind",
					isTieWin = type === "tie_all",

					// orange area
					isSum = /s\d/.test(type),

					isPurpleArea = /(odd|even),(odd|even)/.test(tebak) && type === "pairs",
					// grey area
					isAny = /^any(_number)?$/.test(type),
					isYellowArea = /(low|high),(low|high)/.test(tebak) && type === "pairs";

				item.convertedTebak = (
					<div key={"tHD_det_" + game + "_" + periode + "_" + idbel + "_" + idx}
						className={"detail-transaction m39"}>

						{
							isRedWin ? (
								<div
									style={{ backgroundColor: colours.red, ...baseStyle }}>
									{item.tebak}
								</div>
							) : isBlueWin ? (
								<div
									style={{ backgroundColor: colours.blue, ...baseStyle }}>
									{item.tebak}
								</div>
							)

							// Single dice
							: isD1Red ? (
								<div
									style={ baseStyle }>
									{assetImg("m39", `red_${d1RedValue}`, `red_${idx}`)}
								</div>
							) : isD1Blue ? (
								<div
									style={ baseStyle }>
									{assetImg("m39", `blue_${d1BlueValue}`, `blue_${idx}`)}
								</div>
							)
							
							: isTieNum || isTieWin ? (
								<div
									// className={"circle"}
									style={{ backgroundColor: colours.green, ...baseStyle, ...blackFont }}>
									{item.tebak}
								</div>
							) : isSum ? (
								<div
									// className={"circle"}
									style={{ backgroundColor: colours.orange, ...baseStyle, ...blackFont }}>
									{item.tebak}
								</div>
							)

								// Bottom
								: isAny ? (
									<div
										// className={"circle"}
										style={{ backgroundColor: colours.grey, ...whiteFont }}>
										{item.tebak}
									</div>
								) : isPurpleArea ? (
									<div
										style={{ backgroundColor: colours.purple, ...baseStyle }}>
										{item.tebak}
									</div>
								) : isYellowArea ? (
									<div
										style={{ backgroundColor: colours.yellow, ...baseStyle, ...blackFont }}>
										{item.tebak}
									</div>
								) : (
									<div>
										{item.tebak} - {item.type}
									</div>
								)
						}
					</div>
				)
			});
			break;

		// Skip the other games
		default: break;
	}
}

function toggleTransactionDetail(e: React.MouseEvent) {
	const mainClass = this;

	let game = "", periode = 0, idbel = "";

	if (e) {
		game = e.currentTarget.getAttribute("game");
		periode = Number(e.currentTarget.getAttribute("periode"));
		idbel = e.currentTarget.getAttribute("idbel");
	} else alert("Incomplete request, cancelling.");

	const transactionHistoryData = mainClass.state.transactionHistoryData;
	const filtered = transactionHistoryData.transaction.filter((item: any) => item.idbel === idbel);

	const index = transactionHistoryData.transaction.indexOf(filtered[0]);
	// transactionHistoryData.transaction[index].transactionDetail = data;
console.warn(transactionHistoryData);

	if (!transactionHistoryData.transaction[index]?.transactionDetail)
		fetchTransactionDetail(this, { game: game, periode: periode, idbel: idbel, tglbel: transactionHistoryData.transaction[index].tglbel });

		console.warn(transactionHistoryData);

	//Toggles show transaction detail
	transactionHistoryData.transaction[index].showTransactionDetail =
		!transactionHistoryData.transaction[index].showTransactionDetail;

	mainClass.setState({
		transactionHistoryData: transactionHistoryData
	});
	// showTransactionDetail
}

export {
	defaultTransactionHistoryState,

	fetchTransactionHistory,
	changeTransactionPage,
	toggleTransactionDetail
}